import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  collection,
  query,
  where,
  limit,
  getDocs,
  getDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";

import Name from "../components/packageSoloComponents/unpublishedComponents/Name";
import Gallery from "../components/packageSoloComponents/unpublishedComponents/Gallery";
import PhotoCams from "../components/packageSoloComponents/unpublishedComponents/PhotoCams";
import PhotoEquipment from "../components/packageSoloComponents/unpublishedComponents/PhotoEquipment";
import VideoCams from "../components/packageSoloComponents/unpublishedComponents/VideoCams";
import VideoEquipment from "../components/packageSoloComponents/unpublishedComponents/VideoEquipment";
import Price from "../components/packageSoloComponents/unpublishedComponents/Price";
import Description from "../components/packageSoloComponents/unpublishedComponents/Description";
import PreShoot from "../components/packageSoloComponents/unpublishedComponents/PreShoot";
import DuringShoot from "../components/packageSoloComponents/unpublishedComponents/DuringShoot";
import PostShoot from "../components/packageSoloComponents/unpublishedComponents/PostShoot";
import AboutProfessional from "../components/packageSoloComponents/unpublishedComponents/AboutProfessional";

export default function PackagesSoloUnpublished() {
  const params = useParams();
  const { nameUrl } = params;

  const [packageShow, setPackageShow] = useState();
  const [packageDocReady, setPackageDocReady] = useState(false);
  const [profile, setProfile] = useState();
  const [profileDocReady, setProfileDocReady] = useState(false);
  const [docId, setDocId] = useState();
  const hostname = window.location.hostname;

  const iconClass = {
    artist1: "w-8 h-8 fill-current text-orange-400",
    artist2: "w-8 h-8 fill-none stroke-orange-400 stroke-2",
  };
  const containerClass = "m-2 flex items-center";
  const heading = "ml-2 md:ml-0 text-xl font-bold";

  useEffect(() => {
    console.log("nameUrl: ", nameUrl);
  });

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "packages");
      const q = query(colRef, where("nameUrl", "==", nameUrl), limit(1));
      const snapshot = await getDocs(q);
      const docSnap = snapshot.docs[0];

      console.log("q: ", q);
      console.log("Snapshot: ", snapshot);
      console.log("docSnap data: ", docSnap.data());
      console.log("Doc Id: ", docSnap.id);

      setPackageShow(docSnap.data());
      setDocId(docSnap.id);
      setPackageDocReady(true);
    })();
  }, [nameUrl]);

  useEffect(() => {
    if (hostname === "localhost") {
      console.log("Local Package: ", packageShow);
      console.log("Doc Id: ", docId);
      console.log("Package Doc Ready: ", packageDocReady);
      console.log("profile: ", profile);
    }
  }, [packageShow, docId, packageDocReady, hostname, profile]);

  useEffect(() => {
    if (packageShow) {
      console.log("useEffect, pull profiles");
      const docRef = doc(db, "profiles", packageShow.user);
      getDoc(docRef).then((snapshot) => {
        setProfile(snapshot.data());
        setProfileDocReady(true);
      });

      //   if (hostname === "localhost") {
      //     console.log("Package: ", packageShow);
      //   }
    }
  }, [packageShow]); //eslint-disable-line

  return (
    <>
      {packageDocReady && (
        <div autoFocus className="">
          <Name packageShow={packageShow} />
          <div className=" md:w-4/5 mx-auto divide-y divide-gray-200">
            <Gallery
              packageShow={packageShow}
              packageDocReady={packageDocReady}
              docId={docId}
              nameUrl={nameUrl}
            />
            <Description
              packageShow={packageShow}
              packageDocReady={packageDocReady}
            />
            <PreShoot
              packageShow={packageShow}
              packageDocReady={packageDocReady}
              heading={heading}
            />
            <DuringShoot
              packageDocReady={packageDocReady}
              packageShow={packageShow}
              heading={heading}
            />
            <PostShoot
              packageDocReady={packageDocReady}
              packageShow={packageShow}
              heading={heading}
            />
            {packageShow.services.includes("photography") && (
              <>
                <PhotoCams
                  packageShow={packageShow}
                  packageDocReady={packageDocReady}
                  iconClass={iconClass}
                  containerClass={containerClass}
                  heading={heading}
                />
                <PhotoEquipment
                  packageShow={packageShow}
                  packageDocReady={packageDocReady}
                  iconClass={iconClass}
                  containerClass={containerClass}
                  heading={heading}
                />{" "}
              </>
            )}

            {packageShow.services.includes("videography") && (
              <>
                <VideoCams
                  packageShow={packageShow}
                  packageDocReady={packageDocReady}
                  iconClass={iconClass}
                  containerClass={containerClass}
                  heading={heading}
                />
                <VideoEquipment
                  packageShow={packageShow}
                  packageDocReady={packageDocReady}
                  iconClass={iconClass}
                  containerClass={containerClass}
                  heading={heading}
                />
              </>
            )}

            <AboutProfessional
              packageShow={packageShow}
              packageDocReady={packageDocReady}
              heading={heading}
              profile={profile}
              profileDocReady={profileDocReady}
            />
            <Price
              profile={profile}
              packageShow={packageShow}
              packageDocReady={packageDocReady}
            />
          </div>
        </div>
      )}
    </>
  );
}
